import {COOKIE_LOGIN_AUTH} from '@jobseeker/common-core/constants';
import {recruiterService} from '@jobseeker/common-core/services';
import axios from 'axios';
import {getCookie} from 'cookies-next';

const GLADIATOR_URL = process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR || '';

export const TALENT_BRIDGE_REC_ID = '180511';

export const AdsSlot = {
  COMPANY_LOGOS_TALENT_BRIDGE_DRIVE: '673ecaa0f46ad596cce5657c',
  IMAGE_CAROUSEL: '6728767f975b01b34ee3494d',
  LANDING_PAGE_IMAGE: '67ef719a4c43a35406255aca',
};

export type DriveBanner = {
  title?: string;
  text?: string;
  eligibility?: string;
  date?: string;
  venue?: string;
  imageUrl?: string;
  eventDates?: string;
  ctaText?: string;
  ctaText2?: string;
  month?: string;
  recruiterId?: string;
  detailPageImageCarousel?: string[];
  companyLogos?: string[];
};

export const fetchTalentBridgeAllLocations = async (): Promise<
  Record<string, unknown>
> => {
  const url = process.env.NEXT_PUBLIC_TALENT_BRIDGE_ALL_LOCATIONS || '';
  const response = await axios.get<Record<string, unknown>>(url);
  return response?.data || {};
};

export const getNewDriveBannerData = async (city: string = 'bangalore') => {
  try {
    const cityKey = city.toLowerCase();
    const locations = await fetchTalentBridgeAllLocations();
    const data = locations[cityKey];
    if (!data) return [];
    return data;
  } catch (e) {
    console.error('Error fetching drive banner data:', e);
    return [];
  }
};

export const talentBridgeContants = {
  redirectionUrl_perm: 'jobfeed',
  redirectionUrl_temp: 'talent-bridge-detail',
  refCode_perm: 'bridge_permanent',
  refCode_temp: 'bridge_online',
};

export const getTalentBridgeJobData = async () => {
  try {
    const response = await axios.get(
      `${GLADIATOR_URL}/job/campaign/talent-bridge-jobs`
    );
    if (
      !(
        response &&
        response.data &&
        response.data.data &&
        response.data.data.jobs
      )
    ) {
      return [];
    }
    return response.data.data.jobs;
  } catch (error) {
    console.error('Error fetching talent bridge jobs data:', error);
    return [];
  }
};

export const getTalentBridgeCompanyLogos = async (jobId: string) => {
  try {
    const response = await recruiterService.getCompanyLogo('/company-logo', {
      jobId,
    });
    if (
      !(
        response &&
        response.data &&
        response.data.data &&
        response.data.data.jobs
      )
    ) {
      return [];
    }
    return response.data.data.jobs;
  } catch (error) {
    console.error('Error fetching talent bridge jobs data:', error);
    return [];
  }
};

export const setCampaignData = async (
  refCode = talentBridgeContants.refCode_temp,
  campaignLocation = 'bangalore'
) => {
  try {
    const data = {
      refCode: refCode,
      source: 'web',
      campaignLocation: campaignLocation,
    };
    const cookie = getCookie(COOKIE_LOGIN_AUTH, {
      domain:
        process.env.NEXT_PUBLIC_TRAIL === 'true'
          ? 'localhost'
          : process.env.NEXT_PUBLIC_DOMAIN,
    });
    await axios.post(`${GLADIATOR_URL}/user/campaign/tracker`, data, {
      headers: {Authorization: 'Bearer ' + cookie},
    });
  } catch (error) {
    console.error('Failed to submit campaign data:', error);
    throw error;
  }
};

type TalentBridgeBanner = {
  subText?: string;
};

export const getMonthAndCityFromTalentBridgeObject = (
  obj: TalentBridgeBanner
) => {
  let month = null;
  let city = null;
  const subText = obj.subText || '';
  const bulletsArray = subText.split('~~');
  if (bulletsArray.length > 1 && typeof bulletsArray[1] === 'string') {
    const datePart = bulletsArray[1];
    const dateSplit = datePart.split(',');
    if (dateSplit.length > 0) {
      const dateWords = dateSplit[0].trim().split(' ');
      if (dateWords.length > 0) {
        month = dateWords[dateWords.length - 1];
      }
    }
  }
  if (bulletsArray.length > 2 && typeof bulletsArray[2] === 'string') {
    const locationPart = bulletsArray[2];
    const locationSplit = locationPart.split(',');
    if (locationSplit.length > 1) {
      city = locationSplit[1].trim();
    }
  }
  return {month, city};
};

export const extractDate = (date: string, month: string) => {
  const extractedDate = date.split(' ')[0].trim();
  const dateMonth = extractedDate + ' ' + month;
  return dateMonth;
};

// Utility to parse '21st June' to Date object for the current year
export const parseDayMonthString = (
  dateStr: string,
  year: number
): Date | null => {
  if (!dateStr) return null;
  const cleaned = dateStr.replace(/(st|nd|rd|th)/, '');
  const [dayStr, monthStr] = cleaned.split(' ').map(s => s.trim());
  const day = parseInt(dayStr, 10);
  if (!day || !monthStr) return null;
  const month = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ].findIndex(m => m === monthStr.toLowerCase());
  if (month === -1) return null;
  return new Date(year, month, day);
};
